import { CascadeAppliesParams } from "../service"
export enum ActionState {
  AccessCode = '5',
  AuthInfo = '6',
}
export type AllState = typeof ApplyState | typeof ActionState
export enum ApplyState {
  // 待审核
  Preview = '1',
  // 同意
  Allowed = '2',
  // 拒绝
  Rejected = '3',
  // 断开连接
  Disconnect = '4',
}
export enum BtnActionType {
  Revoke = 'revoke',
  Approving = 'approving',
  Confirm = 'confirm',
  Disconnect = 'disconnect',
  Submit = 'submit',
  Cancel = 'cancel',
  ReNew = 'reNew',
}
export type ApplyStateKeys = keyof typeof ApplyState
export type ApplyStateValues = Exclude<(typeof ApplyState)[ApplyStateKeys], ApplyState.Preview>
export type StateType = Record<ApplyState, { name: string, title: string, type: 'info' | 'success' | 'danger' | 'info', cancelText: string,icon?:string, confirmText: string, cancelEventType?: BtnActionType, btn2Type?: BtnActionType }>
export enum ActionTypes {
  // 级联信息
  Info = '0',
  // 接入码
  AccessCode = '1',
  // 授权管理
  Auth = '2',
}
export const State: StateType = {
  [ApplyState.Preview]: { name: '待审核', title: '待审核',icon: 'el-icon-minus', type: 'info', cancelText: '撤销审批', confirmText: '审批中', cancelEventType: BtnActionType.Revoke, btn2Type: BtnActionType.Approving, },
  [ApplyState.Allowed]: { name: '已同意',icon: 'el-icon-circle-check', title: '已连接', type: 'success', cancelText: '断开连接', confirmText: '确定', cancelEventType: BtnActionType.Disconnect, btn2Type: BtnActionType.Confirm, },
  [ApplyState.Rejected]: { name: '已拒绝',icon: 'el-icon-circle-close', title: '已拒绝', type: 'danger', cancelText: '取消', confirmText: '申请审批', cancelEventType: BtnActionType.Cancel, btn2Type: BtnActionType.Submit, },
  [ApplyState.Disconnect]: { name: '已失效',icon:'el-icon-circle-close', title: '未连接', type: 'info', cancelText: '取消', confirmText: '申请审批', cancelEventType: BtnActionType.Cancel, btn2Type: BtnActionType.Submit, },
}
export const ActionType = {
  [ActionTypes.Info]: State,
  [ActionTypes.AccessCode]: { [ActionState.AccessCode]: { cancelText: '取消', confirmText: '重新生成', cancelEventType: BtnActionType.Cancel, btn2Type: BtnActionType.ReNew } },
  [ActionTypes.Auth]: { [ActionState.AuthInfo]: { cancelText: '取消', confirmText: '确定', cancelEventType: BtnActionType.Cancel, btn2Type: BtnActionType.Submit } }
}
export const ApprovalStateLabel = Object.entries(State).reduce((p, [k, v], i) => ((p[k] = v.name), p), {})
export enum PermissionsState {
  Password_free_login = 'password_free_login',
  Get_upgrade = 'get_upgrade',
  Get_patch = 'get_patch',
  Sync_log = 'sync_log',
  Get_virus = 'get_virus'
}
export const PermissionsText = {
  [PermissionsState.Password_free_login]: '允许上级登录控制中心',
  [PermissionsState.Get_upgrade]: '从上级获取升级数据',
  [PermissionsState.Get_patch]: '从上级获取补丁数据',
  [PermissionsState.Sync_log]: '同步风险日志给上级',
  [PermissionsState.Get_virus]: '从上级获取病毒库数据',
}
export type Permissions = keyof typeof PermissionsText
export type ApproveQueryForm = Partial<CascadeAppliesParams>
export type ExcludeRequestParamsApprove = Exclude<keyof CascadeAppliesParams, 'limit' | 'page'>
